<ng-container *ngIf="scope">

  <!-- ── Top bar ─────────────────────────────────────────────────────────── -->
  <header class="cmn-header" [style.--nav-background]="scope.config.navBackgroundColor || null">
    <div class="cmn-header__inner">
      <div appImgEditContainer="nav" [path]="scope.uploadImageIcon?.logo" name="Logo" [class.disabled_div]="(scope.isPreviewMode$ | async)">
        <a class="cmn-header__logo-wrap" disabledDiv href="/">
          <img class="cmn-header__logo" [src]="scope.component.assets.logo" [alt]="scope.portalName" [ngStyle]="{'max-width': (scope.config.logoSize || '76')+'px'}">
        </a>
      </div>
      <button class="cmn-header__burger" (click)="openMenu()" aria-label="Open navigation menu">
        <mat-icon>menu</mat-icon>
      </button>
    </div>
  </header>

  <!-- ── Backdrop ───────────────────────────────────────────────────────── -->
  <div class="cmn-backdrop" *ngIf="menuOpen" (click)="closeMenu()"></div>

  <!-- ── Slide panel ────────────────────────────────────────────────────── -->
  <div class="cmn-panel" [class.cmn-panel--open]="menuOpen" role="dialog" aria-modal="true">

    <div class="cmn-panel__header">
      <button class="cmn-panel__close" (click)="closeMenu()" aria-label="Close navigation menu">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <nav class="cmn-nav" disabledDiv>
      <ng-container *ngIf="(scope.userChanged$ | async) else unauthenticated">
        <ng-container *ngTemplateOutlet="authenticated"></ng-container>
      </ng-container>
    </nav>

  </div>

  <!-- ── Route templates ────────────────────────────────────────────────── -->
  <ng-template #unauthenticated>
    <ng-container *ngIf="(scope.routes$ | async) as routes">
      <ng-container *ngFor="let route of routes.unauthenticatedRoutes">
        <a class="cmn-nav__item" *ngIf="!route.externalLink"
           [routerLink]="route.link"
           [routerLinkActive]="['cmn-nav__item--active']"
           [routerLinkActiveOptions]="route.routerLinkActiveOptions || {}"
           (click)="closeMenu()"
           [innerText]="scope.getText | transform:route.textMapKey">
        </a>
        <a class="cmn-nav__item" *ngIf="route.externalLink"
           [href]="route.externalLink"
           (click)="closeMenu()"
           [innerText]="scope.getText | transform:route.textMapKey">
        </a>
      </ng-container>
    </ng-container>
    <a class="cmn-nav__link-button" [href]="scope.config.agencyWebsite" *ngIf="scope.config.agencyWebsite" target="_blank" rel="noopener" (click)="closeMenu()">
      Back to main site <mat-icon inline="true">open_in_new</mat-icon>
    </a>
  </ng-template>

  <ng-template #authenticated>
    <ng-container *ngIf="(scope.routes$ | async) as routes">
      <ng-container *ngFor="let route of routes.authenticatedRoutes">
        <a class="cmn-nav__item" *ngIf="!route.externalLink"
           [class.disabled_div]="route.link === '/logout' && (scope.isPreviewMode$ | async)"
           [routerLink]="route.link"
           [routerLinkActive]="['cmn-nav__item--active']"
           [routerLinkActiveOptions]="route.routerLinkActiveOptions || {}"
           (click)="closeMenu()"
           [innerText]="scope.getText | transform:route.textMapKey">
        </a>
        <a class="cmn-nav__item" *ngIf="route.externalLink"
           [href]="route.externalLink"
           (click)="closeMenu()"
           [innerText]="scope.getText | transform:route.textMapKey">
        </a>
      </ng-container>
    </ng-container>
    <a class="cmn-nav__link-button" [href]="scope.config.agencyWebsite" target="_blank" rel="noopener" (click)="closeMenu()">
      Back to main site <mat-icon inline="true">open_in_new</mat-icon>
    </a>
  </ng-template>

</ng-container>
